import { createFileRoute, redirect } from "@tanstack/react-router";
import { RevistaStarContent, type StarOffer } from "@/components/funis/RevistaStarContent";

const CHECKOUT_URL_DEFAULT = "https://chk.eduzz.com/1716431?cupom=CERTIFICACAO&df=1&np=10";

const OFFER: StarOffer = {
  from: "R$597",
  now: "R$197",
  ctaLabel: "Assine a vitalícia por R$197",
};

const CERT_STAR_FAQ = [
  { q: "Como iniciar o meu acesso?", a: "Após a confirmação do pagamento você recebe um e-mail com as instruções e o acesso imediato à plataforma." },
  { q: "O acesso é vitalício mesmo?", a: "Sim. É um pagamento único de R$197 e o acesso à Star Cursos é vitalício, sem renovação anual e sem mensalidade." },
  { q: "Preciso pagar de novo no ano que vem?", a: "Não. Nesta oferta o pagamento é único: você não paga renovação nem mensalidade em nenhum momento." },
  { q: "Os cursos novos também entram no meu acesso?", a: "Sim. A biblioteca é atualizada com novos cursos e você recebe tudo o que for lançado, sem custo adicional." },
  { q: "Tem certificado?", a: "Sim, você pode emitir certificado de cada curso que concluir, sem custo adicional." },
  { q: "Como tirar dúvidas na plataforma?", a: "Em cada videoaula você pode fazer anotações e enviar perguntas. Os professores respondem regularmente." },
  { q: "As aulas são online?", a: "Sim, todas as aulas são gravadas e 100% online." },
];

export const Route = createFileRoute("/certificacao-star")({
  beforeLoad: ({ location }) => { throw redirect({ href: `/star${new URL(location.href, "https://fisioemortopedia.com.br").search}`, statusCode: 301 }); },
  head: () => ({
    meta: [
      { title: "Sua certificação está garantida! · Star Cursos vitalícia R$197 | FEO" },
      {
        name: "description",
        content:
          "Sua matrícula na Certificação foi confirmada. Aproveite a oferta exclusiva: acesso vitalício à Star Cursos por R$197 (de R$597), +120 cursos com certificado.",
      },
      { property: "og:title", content: "Star Cursos vitalícia por R$197" },
      { property: "og:description", content: "Oferta exclusiva para quem acabou de garantir a Certificação: acesso vitalício por R$197." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex,nofollow" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: CERT_STAR_FAQ.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: () => (
    <RevistaStarContent
      defaultCheckoutUrl={CHECKOUT_URL_DEFAULT}
      confirmationText="Matrícula na Certificação confirmada!"
      offer={OFFER}
      faq={CERT_STAR_FAQ}
      heroTitle={
        <>
          Só hoje: leve a{" "}
          <span className="bg-gradient-to-r from-[#6ee7c7] via-[#00c9d6] to-[#00b899] bg-clip-text text-transparent">
            Star Cursos vitalícia por apenas R$197
          </span>
        </>
      }
      heroSubtitle={
        <>
          Pagamento <span className="text-white font-semibold">único</span>, acesso{" "}
          <span className="text-white font-semibold underline decoration-[#00b899]/70 underline-offset-4">
            para sempre
          </span>{" "}
R$400 de desconto.
        </>
      }
    />
  ),
});
